// Avatar storage using IndexedDB (for large images that don't fit in localStorage)

const DB_NAME = 'way2will_avatar_db';
const DB_VERSION = 1;
const STORE_NAME = 'avatars';
const AVATAR_KEY = 'user_avatar';

let dbPromise: Promise<IDBDatabase> | null = null;

function openDB(): Promise<IDBDatabase> {
    if (dbPromise) return dbPromise;

    dbPromise = new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, DB_VERSION);

        request.onerror = () => {
            console.error('[AvatarStorage] Failed to open database:', request.error);
            reject(request.error);
        };

        request.onsuccess = () => {
            resolve(request.result);
        };

        request.onupgradeneeded = (event) => {
            const db = (event.target as IDBOpenDBRequest).result;
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME);
            }
        };
    });

    return dbPromise;
}

export async function saveAvatar(avatarDataUrl: string): Promise<void> {
    try {
        const db = await openDB();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(STORE_NAME, 'readwrite');
            const store = transaction.objectStore(STORE_NAME);
            const request = store.put(avatarDataUrl, AVATAR_KEY);

            request.onsuccess = () => {
                console.log('[AvatarStorage] Avatar saved successfully');
                resolve();
            };
            request.onerror = () => {
                console.error('[AvatarStorage] Failed to save avatar:', request.error);
                reject(request.error);
            };
        });
    } catch (error) {
        console.error('[AvatarStorage] Error saving avatar:', error);
        throw error;
    }
}

export async function loadAvatar(): Promise<string | null> {
    try {
        const db = await openDB();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(STORE_NAME, 'readonly');
            const store = transaction.objectStore(STORE_NAME);
            const request = store.get(AVATAR_KEY);

            request.onsuccess = () => {
                resolve(request.result || null);
            };
            request.onerror = () => {
                console.error('[AvatarStorage] Failed to load avatar:', request.error);
                reject(request.error);
            };
        });
    } catch (error) {
        console.error('[AvatarStorage] Error loading avatar:', error);
        return null;
    }
}

export async function deleteAvatar(): Promise<void> {
    try {
        const db = await openDB();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(STORE_NAME, 'readwrite');
            const store = transaction.objectStore(STORE_NAME);
            const request = store.delete(AVATAR_KEY);

            request.onsuccess = () => {
                console.log('[AvatarStorage] Avatar deleted');
                resolve();
            };
            request.onerror = () => {
                console.error('[AvatarStorage] Failed to delete avatar:', request.error);
                reject(request.error);
            };
        });
    } catch (error) {
        console.error('[AvatarStorage] Error deleting avatar:', error);
        throw error;
    }
}
